import styled from "@emotion/styled/macro";

export const VaultUploadHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
    padding: 10px 16px 10px 40px;
    width: 100%;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
`;

export const VaultUploadHeaderTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const VaultUploadHeaderTitleLine = styled.div`
    width: 1px;
    height: 32px;
    background: var(--Main-Colors-Light-Grey-2, #DDE3EB);
`;

export const VaultUploadHeaderRight = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const VaultUploadHeaderSecureTag = styled.div`
    display: inline-flex;
    height: 36px;
    padding: 0px 12px 0px 8px;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    border-radius: 8px;
    background: var(--Main-Colors-Light-Grey-2, #F1F3F5);

    color: var(--Dark-Gray-2, #585D66);
    font-size: 16px;
    font-weight: 450;
`;

export const VaultUploadHeaderClose = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    cursor: pointer;

    ${({ disabled }) => disabled && `
        opacity: 0.5;
        pointer-events: none;
    `}

    &:hover {
        filter: brightness(0.8);
    }
`;